// extracted by mini-css-extract-plugin
module.exports = {"InstagramShowcase":"InstagramShowcase_InstagramShowcase__IjVng","list":"InstagramShowcase_list__4B0_E","icon":"InstagramShowcase_icon__nrGm_"};